import React, { useEffect, useState } from "react";
import styles from "./CitySelector.module.scss";
import Select from "react-select";

const CitySelector = ({
  selectorStyle = null,
  options,
  id,
  placeholder,
  onChange = null,
  onInputChange = null,
  value = undefined,
  noOptionsMessage = null,
  style = null,
  isSearchable = true,
  notFounded = null,
  disabled,
}) => {
  const [val, setVal] = useState(value);
  const [saveVal, setSaveVal] = useState(val);
  const [valChanged, setValChanged] = useState(false);

  useEffect(() => {
    setVal(value);
  }, [value]);
  const colourStyles = {
    container: (styles) => ({
      ...styles,
      width: style?.width ? style?.width : "100%",
      maxWidth: style ? "100%" : "316px",
    }),
    control: (styles, state) => ({
      ...styles,
      selectorStyle,
      border: state.isFocused
        ? "1px solid #37333F"
        : selectorStyle?.control
        ? selectorStyle?.control().border
        : "1px solid #C1C4CA",
      boxShadow: 0,
      borderRadius: "4px",
      marginRight: "auto",
      transition: ".2s ease-in-out",
      zIndex: 1,
      padding: "3px",
      minHeight: "44px",
      "&:hover": { bac: "1px solid #37333F" },
      backgroundColor: "#FFFFFF",
    }),
    input: (styles) => ({ ...styles, border: "none" }),
    placeholder: (styles) => ({
      ...styles,
      fontWeight: "normal",
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "17px",
      letterSpacing: "-0.01em",
      color: selectorStyle?.placeholder
        ? selectorStyle?.placeholder().color
        : "#C1C4CA",
      padding: "12px 12px 12px 3px",
      marginLeft: "0",
    }),
    menu: (styles, state) => {
      return {
        ...styles,
        zIndex: 3,
        marginTop: 0,
        borderRadius: "0 0 8px 8px",
        boxShadow: "0px 10px 20px 0px rgba(49,8,8,0.1)",
      };
    },
    menuList: (styles) => ({
      ...styles,
      paddingTop: "8px",
      paddingBottom: "12px",
    }),
    valueContainer: (styles) => ({
      ...styles,
      paddingLeft: "12px",
    }),
    singleValue: (styles) => ({
      ...styles,
      maxWidth: "calc(100% - 15px)",
    }),
    option: (styles, state) => {
      let bacColor = "transparent";
      if (state.isFocused) bacColor = "#F6F7F8";
      if (state.isSelected) bacColor = "#F6F7F8";
      return {
        ...styles,
        backgroundColor: bacColor,
        "&:active": { backgroundColor: "#F73E3E" },
      };
    },
  };

  const onMenuOpen = () => {
    setSaveVal(val);
    setVal("");
    setValChanged(false);
  };

  const onMenuClose = () => {
    if (!valChanged) {
      setVal(saveVal);
    }
  };

  const onInpChange = (event) => {
    if (onInputChange) {
      onInputChange(event);
      setValChanged(true);
    }
  };

  const onChng = (event) => {
    if (onChange) {
      onChange(event);
      setVal(event);
      setValChanged(true);
    }
  };

  return (
    <div className={styles.selectorPane}>
      <Select
        className={"selectorpane"}
        id={id}
        instanceId={id}
        inputId={id}
        options={options}
        styles={colourStyles}
        isSearchable={isSearchable}
        placeholder={placeholder}
        onInputChange={onInpChange}
        onChange={onChng}
        value={val}
        inputProps={{
          readOnly: true,
        }}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        maxMenuHeight={230}
        noOptionsMessage={() => {
          return noOptionsMessage ? noOptionsMessage : "Не найдено";
        }}
        isDisabled={disabled}
      />
      {notFounded && (
        <span className={styles.NotFounded}>
          Если не нашли свой город,
          <br />
          напишите нам на{" "}
          <a href="mailto:support@donorsearch.org">support@donorsearch.org</a>
        </span>
      )}
    </div>
  );
}

export default CitySelector